import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'inaccessible-wall-dialog',
  templateUrl: './inaccessible-wall-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InaccessibleWallDialogComponent {
  constructor(private _dialogRef: MatDialogRef<InaccessibleWallDialogComponent>, @Inject(MAT_DIALOG_DATA) public data) {}

  ngOnInit(): void {}

  closeDialog(): void {
    this._dialogRef.close();
  }
}
